export default ({
  isFemale,
  word,
  wordFemale
}) => isFemale ? (wordFemale || `${word}e`) : word
